import { Component } from '@angular/core';
@Component({
  selector: 'app-dashboard',
  templateUrl: '../../templates/dashboard/dashboard.component.html'
})
export class DashboardComponent {

  constructor(){
  }
}



// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dashboard/dashboard.component.ts